// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"67cc9954","839":"68236866"}[chunkId] + ".chunk.js";
};